<template>
<div class="chapter">
<div class="inner_page">
<p class="c5" id="calibre_pb_3"> <br class="calibre2"/></p>
<p class="c7">To Amelia,</p>
<p class="c7">You’re not even born yet and</p>
<p class="c7">you already have a book dedicated to you.</p>
<p class="c7">I love you.</p>
<p class="c6"> <br class="calibre2"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?4ccb7520